"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutType = void 0;
var PayoutType;
(function (PayoutType) {
    PayoutType[PayoutType["Mangopay"] = 0] = "Mangopay";
    PayoutType[PayoutType["Paypal"] = 1] = "Paypal";
    PayoutType[PayoutType["Other"] = 2] = "Other";
    PayoutType[PayoutType["Cash"] = 3] = "Cash";
    PayoutType[PayoutType["BankTransaction"] = 4] = "BankTransaction";
    PayoutType[PayoutType["Hyperwallet"] = 5] = "Hyperwallet";
    PayoutType[PayoutType["Stripe"] = 6] = "Stripe";
})(PayoutType || (exports.PayoutType = PayoutType = {}));
//# sourceMappingURL=PayoutType.js.map